<template>
  <div>
    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      max-items="100"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div
        class="mt-6 flex items-center justify-between px-6"
        v-if="productGroup"
      >
        <div class="flex items-center">
          <img width="40" :src="ProductIcon" class="mr-4" />
          <div>
            <h4>Product Group</h4>
            <small v-if="productGroup.name">{{ productGroup.name }}</small>
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <div class="flex flex-col mb-3" v-if="!isNew">
            <div class="mb-1 text-sm">
              <span>Created by</span>
            </div>
            <div>
              <code
                >{{ orgProductGroup.createdBy.username }} at
                {{ orgProductGroup.createdAt | formatDate }}</code
              >
            </div>
          </div>

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Group name</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="productGroup.name" />
            </div>
          </div>

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Categories</span>
            </div>
            <div>
              <vs-select
                class="w-full"
                multiple
                v-model="productGroup.productCategoryIds"
              >
                <vs-select-item
                  :key="category.productCategoryId.id"
                  :value="category.productCategoryId.id"
                  :text="category.name"
                  v-for="category in productCategories"
                />
              </vs-select>
            </div>
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click="create"
          :disabled="!isFormValid"
          v-if="isNew"
        >
          Create
        </vs-button>
        <vs-button
          class="mr-6"
          @click="save"
          :disabled="!isFormValid"
          v-if="!isNew"
        >
          Save
        </vs-button>
        <vs-tooltip :text="orgProductGroup && orgProductGroup.productCategories.length !== 0 ? 'Remove all categories and save before deleting group': 'Delete product group permanently'">
          <vs-button
            v-if="!isNew"
            :disabled="
              orgProductGroup && orgProductGroup.productCategories.length !== 0
            "
            color="danger"
            @click="confirmDelete"
          >
            Delete</vs-button
          ></vs-tooltip
        >
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/collection-icon.png";
import { mapGetters } from "vuex";

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,

      isNew: false,
      productGroup: null,
      orgProductGroup: null,
    };
  },
  computed: {
    ...mapGetters({
      stockProducts: "stockProducts/stockProducts",
      productCategories: "productCategories/productCategories",
    }),
    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    async showEmpty() {
      this.isActive = true;
      this.isLoading = true;
      this.isNew = true;

      this.orgProductGroup = null;

      this.productGroup = {
        name: "",
        productCategoryIds: [],
      };

      await this.loadExternalData();
      this.isLoading = false;
    },
    async show(productGroupId) {
      this.isActive = true;
      this.isLoading = true;
      this.isNew = false;

      var result = await this.$store.dispatch(
        "productGroups/getProductGroup",
        productGroupId
      );

      this.orgProductGroup = result;
      this.productGroup = {
        name: result.name,
        productCategoryIds: result.productCategories.map(
          (e) => e.productCategoryId.id
        ),
      };

      await this.loadExternalData();
      console.log("Got product group", this.productGroup, productGroupId);
      this.isLoading = false;
    },
    async loadExternalData() {
      await this.$store.dispatch("productCategories/getProductCategories");
    },
    confirmDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Delete this product group?`,
        accept: this.deleteSchema,
      });
    },
    async deleteSchema() {
      await this.$store.dispatch(
        "productGroups/deleteProductGroup",
        this.orgProductGroup.id
      );

      this.$vs.notify({
        title: "Product group deleted",
        text: "Product group deleted.",
      });

      this.isActive = false;
      this.isLoading = true;
    },
    async save() {
      console.log("Saving DTO", this.productGroup);

      // this.productGroup.id = this.orgProductGroup.id;

      const result = await this.$store.dispatch(
        "productGroups/updateProductGroup",
        {
          id: this.orgProductGroup.id,
          dto: this.productGroup,
        }
      );

      // await new Promise((resolve) => setTimeout(resolve, 1500)); // FIXME - Wait for backend to update

      this.$vs.notify({
        title: "Product group",
        text: "Product group saved.",
      });

      this.isActive = false;
      this.isLoading = true;
    },
    async create() {
      console.log("Creating DTO", this.productGroup);

      const result = await this.$store.dispatch(
        "productGroups/createProductGroup",
        this.productGroup
      );

      //await new Promise((resolve) => setTimeout(resolve, 1500)); // FIXME - Wait for backend to update

      this.$vs.notify({
        title: "Product group created",
        text: "Your product group has been created.",
      });

      this.isActive = false;
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>